import axiosApi from 'modules/api'
import { GetOrderResponse } from 'pages/api/orders/[orderId]'

const fetchOneOrder = async (orderId: string): Promise<GetOrderResponse> => {
  const { data } = await axiosApi.get<GetOrderResponse>(`/orders/${orderId}`)
  return data
}

export default fetchOneOrder
